import styled, { css } from 'styled-components';
import { down } from 'styled-breakpoints';

export const Container = styled.form`
  ${({ theme }) => css`
    width: 100%;
    border-radius: 1.25rem;
    padding: 1.5rem;
    background: ${theme.colors.background[100]};
    border: 1px solid ${theme.colors.base.border};
    box-shadow: ${theme.shadows.sm};
    transition: ${theme.transition.default};

    :focus-within {
      box-shadow: ${theme.shadows.md};
      border-color: ${theme.colors.brand.primary.default};
    }

    ${down('md')} {
      max-width: 100%;
    }
  `}
`;

export const ComposerHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.875rem;
    margin-bottom: 1rem;

    > span {
      font-size: 0.9375rem;
      color: ${theme.colors.foreground[40]};

      strong {
        color: ${theme.colors.foreground[100]};
        font-weight: 700;
      }
    }
  `}
`;

export const Footer = styled.div`
  ${() => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.875rem;
  `}
`;

export const FooterActions = styled.div`
  display: flex;
  gap: 0.375rem;
`;

export const ActionButton = styled.div`
  ${({ theme }) => css`
    width: 2.375rem;
    height: 2.375rem;
    border-radius: 0.75rem;
    background: transparent;
    cursor: pointer;
    color: ${theme.colors.foreground[40]};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: ${theme.transition.default};

    :hover {
      background: ${theme.colors.brand.primary.opaque};
      color: ${theme.colors.brand.primary.default};
    }

    label {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      cursor: pointer;

      input {
        display: none;
      }
    }
  `}
`;

export const FooterRight = styled.div`
  display: flex;
  align-items: center;
`;

export const CharCount = styled.span`
  ${({ theme }) => css`
    font-size: 0.75rem;
    color: ${theme.colors.foreground[40]};
    margin-right: 0.75rem;
  `}
`;

export const SubmitButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.625rem 1.5rem;
    background: ${theme.colors.brand.primary.default};
    color: ${theme.colors.brand.primary.text};
    border: none;
    border-radius: 9999px;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    transition: ${theme.transition.default};

    :hover:not(:disabled) {
      background: ${theme.colors.brand.primary.hover};
      transform: translateY(-1px);
      box-shadow: ${theme.shadows.md};
    }

    :disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  `}
`;

export const PicturePreview = styled.div`
  ${({ theme }) => css`
    position: relative;
    margin-top: 0.75rem;
    border-radius: 0.75rem;
    overflow: hidden;
    max-height: 12rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    > button {
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      border: none;
      background: rgba(0, 0, 0, 0.5);
      color: white;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: ${theme.transition.default};

      :hover {
        background: rgba(0, 0, 0, 0.7);
      }
    }
  `}
`;
